import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SR_API_ACTION_UPDATE_BREED_RESTRICTIONS,
} from 'api/actionTypes';
import {
  transformBooleanToYesNo,
} from 'client/helpers/formikHelpers';

import {
  DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA,
  DATA_TABLE_VIEW_ID_TENANT_SCREENING_CRITERIA_ALL,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableLoadNextPage,
} from 'client/helpers/dataTables';

import postWithState from 'client/actions/postWithState';
import SrTable from 'client/components/SrTable';
import SrText from 'client/components/SrText';
import SrEditBreedRestrictionsModal from 'client/components/SrEditBreedRestrictionsModal';
import SrTenantScreeningCriteriaModal from 'client/components/SrTenantScreeningCriteriaModal';

import withInfiniteScroll from 'client/helpers/withInfiniteScroll';

function getDataTableSettingsFromProps() {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_PARTNER_TENANT_SCREENING_CRITERIA,
    viewId: DATA_TABLE_VIEW_ID_TENANT_SCREENING_CRITERIA_ALL,
    sort: {
      'tenantScreeningCriteria.createdDate': 'desc',
    },
    count: 100,
  };

  return dataTableSettings;
}

@dataTable(getDataTableSettingsFromProps)
@withInfiniteScroll({
  offset: 420,
})
class SrDataTablePartnerTenantScreeningCriteria extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    partnersList: PropTypes.array.isRequired,
    reloadDataTableTenantScreeningCriteriaPerPartner: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    const { onInfiniteScrollCallbackReady } = props;
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);

    this.state = {
      tenantScreeningCriteriaModalProps: null,
      breedRestrictionsTenantScreeningCriteriaId: null,
    };
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, getDataTableSettingsFromProps(this.props));
    }
  }

  _onClickPartnerCol = ({ partnerTenantScreeningCriteria, tenantScreeningCriteria }) => {
    this.setState({
      tenantScreeningCriteriaModalProps: {
        defaultValues: {
          ...tenantScreeningCriteria,
          partnerId: partnerTenantScreeningCriteria.partnerId,
        },
      },
    });
  }

  _onCloseTenantScreeningCriteriaPerPartner = () => {
    this.setState({
      tenantScreeningCriteriaModalProps: null,
    });
  }

  _onClickBreedRestrictionsCol = (breedRestrictionsTenantScreeningCriteriaId) => {
    this.setState({
      breedRestrictionsTenantScreeningCriteriaId,
    });
  }

  _onCloseBreedRestrictionsModal = () => {
    this.setState({
      breedRestrictionsTenantScreeningCriteriaId: null,
    });
  }

  _onBreedRestrictionsModalSubmit = (breedRestrictions) => {
    const {
      items,
      dispatch,
      reloadDataTableTenantScreeningCriteriaPerPartner,
    } = this.props;
    const {
      breedRestrictionsTenantScreeningCriteriaId,
    } = this.state;

    const breedRestrictionsTenantScreeningCriteria = items.find((item) => {
      return item.id === breedRestrictionsTenantScreeningCriteriaId;
    });

    dispatch(postWithState, {
      action: SR_API_ACTION_UPDATE_BREED_RESTRICTIONS,
      payload: {
        partnerId: breedRestrictionsTenantScreeningCriteria.partnerId,
        breedRestrictions,
      },
      onSuccess: () => {
        reloadDataTableTenantScreeningCriteriaPerPartner(
          breedRestrictionsTenantScreeningCriteria
        );
      },
    });

    this._onCloseBreedRestrictionsModal();
  }

  render() {
    const {
      items,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
      partnersList,
      reloadDataTableTenantScreeningCriteriaPerPartner,
      dispatch,
    } = this.props;
    const {
      breedRestrictionsTenantScreeningCriteriaId,
      tenantScreeningCriteriaModalProps,
    } = this.state;

    const breedRestrictionsTenantScreeningCriteria = breedRestrictionsTenantScreeningCriteriaId
      ? items.find((item) => item.id === breedRestrictionsTenantScreeningCriteriaId)
      : null;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        {dataTableApiState.error && (
          <span>ERROR: { dataTableApiState.error }</span>
        )}
        <SrTable
          headers={[
            { content: 'partner name' },
            { content: 'credit score' },
            { content: 'rent to income ratio' },
            { content: 'move-in minimum days' },
            { content: 'move-in date range in days' },
            { content: 'accept felonies?' },
            { content: 'felonies description' },
            { content: 'felonies expiration in months' },
            { content: 'accept bankruptcies?' },
            { content: 'bankruptcies description' },
            { content: 'bankruptcies expiration in months' },
            { content: 'accept evictions ?' },
            { content: 'evictions description' },
            { content: 'evictions expiration in months' },
            { content: 'enrolled in and accept section 8?' },
            { content: 'accept guarator?' },
            { content: 'restricted breeds' },
            { content: 'options' },
          ]}
          rows={items.map(({
            tenantScreeningCriteria,
            partner,
            breedRestrictions,
            ...partnerTenantScreeningCriteria
          }) => ({
            cells: [
              { content: partner.displayName },
              { content: tenantScreeningCriteria.creditScore },
              { content: tenantScreeningCriteria.rentToIncomeRatio },
              { content: tenantScreeningCriteria.moveInMinimumDays },
              { content: tenantScreeningCriteria.moveInDateRangeInDays },
              { content: transformBooleanToYesNo(tenantScreeningCriteria.feloniesAccepted) },
              { content: tenantScreeningCriteria.feloniesDescription || '--' },
              { content: tenantScreeningCriteria.feloniesExpirationInMonths || '--' },
              { content: transformBooleanToYesNo(tenantScreeningCriteria.bankruptciesAccepted) },
              { content: tenantScreeningCriteria.bankruptciesDescription || '--' },
              { content: tenantScreeningCriteria.bankruptciesExpirationInMonths || '--' },
              { content: transformBooleanToYesNo(tenantScreeningCriteria.evictionsAccepted) },
              { content: tenantScreeningCriteria.evictionsDescription || '--' },
              { content: tenantScreeningCriteria.evictionsExpirationInMonths || '--' },
              { content: transformBooleanToYesNo(tenantScreeningCriteria.section8Accepted) },
              { content: transformBooleanToYesNo(tenantScreeningCriteria.guarantorAccepted) },
              { content: (
                <SrText
                  cursor='pointer'
                  color='grey'
                  decoration='underline'
                  onClick={() => this._onClickBreedRestrictionsCol(partnerTenantScreeningCriteria.id)}
                >
                  Edit Restricted Breeds
                </SrText>
              ) },
              { content: (
                <SrText
                  cursor='pointer'
                  color='grey'
                  decoration='underline'
                  onClick={() => this._onClickPartnerCol({
                    partnerTenantScreeningCriteria,
                    tenantScreeningCriteria,
                  })}
                >
                  Edit Screening Criteria
                </SrText>
              ) },
            ],
          }))}
        />
        {dataTableApiState.inProgress && (
          <div className='loading-ellipses left' />
        )}
        {breedRestrictionsTenantScreeningCriteria && (
          <SrEditBreedRestrictionsModal
            onSubmit={this._onBreedRestrictionsModalSubmit}
            onClose={this._onCloseBreedRestrictionsModal}
            initialBreedNamesEnabled={
              breedRestrictionsTenantScreeningCriteria
                .breedRestrictions
                .map(({ name }) => name)
            }
          />
        )}
        {tenantScreeningCriteriaModalProps && (
          <SrTenantScreeningCriteriaModal
            {...tenantScreeningCriteriaModalProps}
            partnersList={partnersList}
            onSubmit={reloadDataTableTenantScreeningCriteriaPerPartner}
            onClose={this._onCloseTenantScreeningCriteriaPerPartner}
            dispatch={dispatch}
          />
        )}
      </div>
    );
  }
}

SrDataTablePartnerTenantScreeningCriteria.displayName = 'SrDataTablePartnerTenantScreeningCriteria';

export default SrDataTablePartnerTenantScreeningCriteria;
